import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';
import ChallengeBanner from './ChallengeBanner';
import SlideInLeadMagnet from '../SlideInLeadMagnet';
import MobileStickyCta from '../MobileStickyCta';
import AIAssistantWidget from '../AIAssistantWidget';
import { hydrateSuppressionFromBackend } from '../../lib/leadMagnetSuppression';

// Canonical site identity (mirrors /public/index.html so social cards stay consistent)
const DEFAULT_TITLE = 'DCA Enterprises Inc. | Executive & Career Coaching by David Ashley';
const DEFAULT_DESC = 'Executive coaching, career strategy, and life-design programs by David C. Ashley. Book a free 20-min Jumpstart, $197 strategy session, or 3/6/12-month coaching.';
const OG_IMAGE = 'https://customer-assets.emergentagent.com/job_736b5617-324a-4027-a0b5-949393e5cf90/artifacts/te4le6nd_Untitled%20design.png';

export default function Layout({ children, title, description }) {
  const pageTitle = title ? `${title} | DCA Enterprises` : DEFAULT_TITLE;
  const pageDesc = description || DEFAULT_DESC;

  // One-time hydration: pull cross-device suppression signals from the
  // backend (logged-in visitors via session cookie) so popups/CTAs honor
  // them immediately, even on a brand new browser/device.
  useEffect(() => { hydrateSuppressionFromBackend(); }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA]">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDesc} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDesc} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={OG_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDesc} />
        <meta name="twitter:image" content={OG_IMAGE} />
      </Helmet>
      <ChallengeBanner />
      <Header />
      <main className="flex-grow pb-[68px] md:pb-0">
        {children}
      </main>
      <Footer />
      <SlideInLeadMagnet />
      <MobileStickyCta />
      <AIAssistantWidget />
    </div>
  );
}
